<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'banner列表',goback:true},{name:'发布banner'}]" :title="'发布banner'"/> -->
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>附件：</div>
                        <div class="content">
                            <upLoadFiles  v-model="sendInfo.fileList" :alone="true" 
							:action="'backstage/annex/file'" :size="20"/>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.fileList']">错误提示：{{errors['sendInfo.fileList']}}</div>
                    <div class="child">
                      <div class="name"></div>
                      <div class="content">
                          <div class="doubleBtn">
                            <el-button size="small" type="primary" @click="submit">确认</el-button>
                            <el-button size="small" @click="$router.back(-1)">取消</el-button>
                            <!-- <el-button size="small" @click="$router.back(-1)">返回</el-button> -->
                        </div>
                      </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../../components/upLoadFiles';
export default {
    components:{
        // breadcrumb,
        upLoadFiles
    },
    data(){
        return{
            sendInfo:{
                fileList:[],//附件
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.fileList':{
            test:function(){
                if(this.sendInfo.fileList.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传附件'
        }
    },
    mounted(){
    },
    methods:{
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                let parme = this.sendInfo.fileList[0]
                parme.type = 0
                this.$axioscBody.post('backstage/front/config/file/save',parme).then(res=>{
                    if(res.code == 200){
						            this.sendInfo.fileList=[]
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        })
                        this.$router.back(-1)
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                    
                })
            }
        },
        //取消
        cancel:function(){
            this.sendInfo.name1=[];
            this.$vuerify.clear();
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding:100px 0;
    .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
    .childList{
        max-width: 700px;
        /deep/ .el-radio{
            margin-top: 10px;
            width: 100px;
        }
    }
}
.error{
  text-indent: 95px !important;
}
.forms{
  .name{
    span{
      color:red;
    }
  }
}
</style>